export default Object.freeze({
    CREATED: 1,
    SUBMITTED: 2,
    APPROVED: 3,
    REJECTED: 4,
    AMENDED: 5,
    PENDING_PAYMENT: 6,
})
